PJQ.nav = {
    getDataForOldProjectModules: function (callback) {
        window.pjqWallContext = 'project';
        new PJQ.ajax.Request({
            endpoint: "/session/project/" + PJQ.app.session.project.id.toString()
        }).get().done(_.bind(function () {
            if (PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId')) {
                let sessionId = window.pjqSessionId ? window.pjqSessionId : PJQ.app.session.id;
                PanteraScript.PanteraScriptService.GetProjectWallAdminSettings(sessionId, window.projectContactTemp != null ? window.projectContactTemp : '', function (settings) {
                    window.settings = $.parseJSON(settings);
                    window.settings.projectId = PJQ.app.session.project.id;
                    if (window.settings.LayoutCompany != null) {
                        window.pjqITBLayoutDefault = window.settings.LayoutCompany;
                    }
                    if (window.settings.LayoutGroupCompany != null) {
                        window.pjqITBLayoutGroupCompany = window.settings.LayoutGroupCompany;
                    }

                    if (window.settings.FieldMappingContact != null) {
                        window.pjqFMContact = window.settings.FieldMappingContact;
                    }

                    let xmlFile = '/DesktopModules/PJQProjectWallAdmin/GetProjectMessageTemplates.aspx?sessionid=' + PJQ.app.session.id + '&x=' + new Date().getTime();
                    jQuery.ajax({
                        type: "GET",
                        url: xmlFile,
                        dataType: "json",
                        success: _.bind(function (result) {
                            window.settings.ProjectMessageTemplates = result;
                            PanteraScript.PanteraScriptService.GetProjectInfo(PJQ.app.session.id, function (project) {
                                window.project = $.parseJSON(project);
                                callback();
                            }, onScriptError);
                        }, this)
                    });
                }, onScriptError);
            } else {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'settings'
                        },
                        {
                            endpoint: 'getsubwallsettings'
                        }
                    ]),
                    isPascal: true
                }).get().done(_.bind(function (settings) {
                    window.settings = settings;
                    PanteraScript.PanteraScriptService.GetProjectInfo(PJQ.app.session.id, function (project) {
                        window.project = $.parseJSON(project);
                        callback();
                    }, onScriptError);
                }, this)).fail(onScriptError);
            }
        }, this));
    }
};
PJQ.nav.NavItem = class {
    constructor(options = {}) {
        this.id = options.id;
        this.title = options.title;
        this.isBeta = options.isBeta === true;
        this.isLegacy = options.isLegacy;
        this.requiresDirectory = options.requiresDirectory === true;
        this.isPrimaryProjectManagerCheckExempt = options.isPrimaryProjectManagerCheckExempt === true;
        this.sortOrder = options.sortOrder;
        this.icon = options.icon;
        this.iconImage = options.iconImage;
        this.iconImageActive = options.iconImageActive;
        this.feature = options.feature;
        this.isActive = options.isActive;
        this.hasRoute = options.hasRoute;
        this.hasPrecedingSeparator = options.hasPrecedingSeparator;
        this.extraMarkup = options.extraMarkup;
        this.includeMarkup = options.includeMarkup;
        this.outsideRoute = options.outsideRoute;
        this.isAdmin = options.isAdmin;
        if (options.route != null) {
            this.route = options.route;
        }
        if (options.count != null) {
            this.count = options.count;
        }
        if (options.render != null) {
            this.render = options.render;
        }
        if (options.hasPermission != null) {
            this.hasPermission = options.hasPermission;
        }
        if (options.path != null) {
            this.path = typeof options.path === 'function' ? options.path : _.noop;
        }
        if (options.isDisabled != null) {
            this.isDisabled = options.isDisabled;
        }

        if (options.requireSignUp != null) {
            this.requireSignUp = options.requireSignUp;
        }

        if (options.leaveView != null) {
            this.leaveView = options.leaveView;
        }
    }

    path() {
        return this.id;
    }

    routeToRoot() {
        if (PJQ.app.session.project != null) {
            PJQ.app.router.navigate('projects/' + PJQ.app.session.project.id.toString(), {
                trigger: true
            });
            return;
        }
        PJQ.app.router.routeToRoot();
    }

    route(options, triggerRoute = true, $navBody = null) {
        if (!this.hasPermission() || !this.hasFeature() || this.getIsDisabled()) {
            this.routeToRoot();
            return false;
        }

        if (options && options.noRoute)
            return;

        if (_.size($navBody) > 0 && this.requiresDirectory && PJQ.app.session.isPanteraPortal() && PJQ.app.session.contact == null) {
            if (PJQ.app.session.user != null && PJQ.app.session.user.get('companyType') === 'SUB') {
                new PJQ.views.nav.RegisterDirectory({
                    el: $navBody,
                    onRegister: _.bind(function () {
                        this.render($navBody, options);
                    }, this),
                    onClose: _.bind(function () {
                        this.routeToRoot();
                    }, this)
                });
            } else {
                this.routeToRoot();
            }
            return false;
        } else {
            PJQ.app.router.navigate(typeof this.path === 'function' ? this.path(options) : this.path, {
                trigger: triggerRoute
            });
        }
    }

    getNavPref() {
        if (this.navPref == null) {
            let prefs;
            if (PJQ.app.session.project != null) {
                prefs = PJQ.app.session.project.preferences;
            } else {
                prefs = PJQ.app.session.preferences;
            }
            let appNavPref = prefs.getPref(PJQ.constants.preferenceTypes.APP_NAV_ITEMS),
                portalNavPref = prefs.getPref(PJQ.constants.preferenceTypes.PORTAL_APP_NAV_ITEMS);
            this.navPref = _.findWhere(_.union(portalNavPref != null ? portalNavPref : [], appNavPref != null ? appNavPref : []), {id: this.id});
        }
        return this.navPref;
    }

    getDocumentTitle() {
        let result = '',
            itemPref = this.getNavPref();
        if (itemPref != null && itemPref.title != null) {
            result = itemPref.title;
        } else {
            result = typeof this.title === 'function' ? this.title() : this.title;
        }

        if (PJQ.app.session.project != null && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_NAME_PAGE_TITLE)) {
            let pName = PJQ.app.session.project.get('projectName'),
                pCity = PJQ.app.session.project.get('city'),
                pState = PJQ.app.session.project.get('state'),
                pLoc = '';
            if (_.size(pCity) > 0) {
                pLoc += pCity;
            }
            if (_.size(pState) > 0) {
                if (_.size(pState) > 0)
                    pLoc += ', ';

                pLoc += pState;
            }
            result = pLoc + ' - ' + pName;
        }

        return result;
    }

    getTitle(html = true) {
        let result = '',
            itemPref = this.getNavPref();
        if (itemPref != null && itemPref.title != null) {
            result = itemPref.title;
        } else {
            result = typeof this.title === 'function' ? this.title() : this.title;
        }

        if (this.isBeta) {
            if (html) {
                result += "<span class='ml-1 fs-12 font-weight-medium'>beta</span>"
            } else {
                result += ' - beta';
            }
        } else if ((typeof this.isLegacy === 'function' && this.isLegacy()) || this.isLegacy === true) {
            if (html) {
                result += "<span class='ml-1 fs-12 font-weight-medium'>legacy</span>"
            } else {
                result += ' - legacy';
            }
        }

        return result;
    }

    getSortOrder() {
        let itemPref = this.getNavPref();
        if (itemPref != null && itemPref.sortOrder != null) {
            return itemPref.sortOrder;
        }
        return this.sortOrder;
    }

    getIsAdmin() {
        let itemPref = this.getNavPref();
        if (itemPref != null && itemPref.isAdmin != null) {
            return itemPref.isAdmin;
        }
        return this.isAdmin;
    }

    getIsDisabled() {
        //only return item pref if its forced to true
        let itemPref = this.getNavPref();
        if (itemPref != null && itemPref.isDisabled) {
            return itemPref.isDisabled;
        }
        return typeof this.isDisabled === 'function' ? this.isDisabled() : this.isDisabled;
    }

    hasPermission() {
        return true;
    }

    hasFeature() {
        if (_.size(this.feature) > 0) {
            if (PJQ.app.session.project != null && PJQ.app.session.project.subscription != null) {
                return PJQ.app.session.project.subscription.hasFeature(this.feature);
            }
            return PJQ.app.session.hasFeature(this.feature);
        }
        return true;
    }

    isDisabled() {
        return false;
    }

    count() {
        return 0;
    }
};

PJQ.nav.NavItemGroup = class {
    constructor(items, options) {
        this.items = items;
        this.options = options ? options : {};
    }
};

PJQ.nav.itemGroups = {
    main: new PJQ.nav.NavItemGroup([
        new PJQ.nav.NavItem({
            id: "myprojects",
            title: "My Projects",
            sortOrder: 10,
            icon: "fa-hammer",
            feature: "projects",
            hasRoute: true,
            render: function ($el) {
                new PJQ.views.projects.MyProjectList({
                    el: $el
                });
            },
            isDisabled: function () {
                return !PJQ.app.session.get('ownsPortal');
            }
        }),
        new PJQ.nav.NavItem({
            id: "biddingprojects",
            title: function () {
                return PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.BIDDING_PROJECTS_TAB_NAME) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.BIDDING_PROJECTS_TAB_NAME) : "Bidding Projects";
            },
            sortOrder: 20,
            icon: "fa-hammer",
            hasRoute: true,
            render: function ($el) {
                new PJQ.views.projects.BiddingProjectsList({
                    el: $el
                });
            },
            isDisabled: function () {
                return PJQ.app.session.get('ownsPortal') || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_BIDDING_PROJECTS);
            }
        }),
        new PJQ.nav.NavItem({
            id: "projectinvites",
            title: "Project Invites",
            sortOrder: 30,
            icon: "fa-envelope",
            hasRoute: true,
            render: function ($el) {
                new PJQ.views.projects.ProjectInvitesList({
                    el: $el
                });
            },
            isDisabled: function () {
                return (PJQ.app.session.user.get('companyType') === 'GC' && PJQ.app.session.contact == null) || (PJQ.app.session.get('ownsPortal') && !PJQ.app.session.isPanteraPortal());
            }
        }),
        new PJQ.nav.NavItem({
            id: "contacts",
            title: "Contacts",
            sortOrder: 40,
            isLegacy: true,
            icon: "fa-users",
            feature: "contacts",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('contacts.canView');
            },
            render: function ($el) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'session'
                        },
                        {
                            endpoint: 'project',
                            value: 0
                        }
                    ])
                }).get().done(_.bind(function () {
                    PJQ.app.session.project = null;
                    window.pjqSessionId = PJQ.app.session.id;
                    window.pjqABContext = '';
                    initAddressBook($el);
                }, this));
            },
            count: function () {
                if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PERMISSIONS)) {
                    if (PJQ.app.session.hasPermission('contacts.canApprove')) {
                        return PJQ.app.session.get('unApprovedContactsCount');
                    } else {
                        return 0;
                    }
                } else {
                    return PJQ.app.session.get('unApprovedContactsCount');
                }
            },
            isDisabled: function () {
                if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_OLD_ADDRESSBOOK)) {
                    return false;
                }
                return PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId || !PJQ.app.session.get('ownsPortal') || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_OLD_ADDRESSBOOK);
            }
        }),
        new PJQ.nav.NavItem({
            id: "contactsnew",
            title: "Contacts",
            sortOrder: 40,
            icon: "fa-users",
            feature: "contacts",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('contacts.canView');
            },
            render: function ($el, options) {
                new PJQ.views.addressbook.AddressBook(_.defaults({
                    el: $el
                }, options));
            },
            count: function () {
                if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PERMISSIONS)) {
                    if (PJQ.app.session.hasPermission('contacts.canApprove')) {
                        return PJQ.app.session.get('unApprovedContactsCount');
                    } else {
                        return 0;
                    }
                } else {
                    return PJQ.app.session.get('unApprovedContactsCount');
                }
            },
            isDisabled: function () {
                return !PJQ.app.session.get('ownsPortal') || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_ADDRESSBOOK);
            }
        }),
        new PJQ.nav.NavItem({
            id: "documents",
            title: "Documents",
            sortOrder: 50,
            icon: "fa-folder",
            feature: "documents",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('documents.canView');
            },
            route: function () {
                if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_DOCUMENTS)) {
                    PJQ.app.router.navigate(this.path(), {
                        trigger: true
                    });
                } else {
                    if (window.location.hash.toLowerCase() !== ('#' + this.path())) {
                        window.location.href = '#' + this.path();
                        window.location.reload();
                        return false;
                    }
                }
            },
            render: function ($el) {
                if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_DOCUMENTS)) {
                    new PJQ.views.files.FileNavigator({
                        el: $el
                    });
                } else {
                    $el.append($('<iframe/>', {
                        src: '/Default.aspx?tabid=' + PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.DOCUMENTS_TAB_ID).toString(),
                        style: 'border:0;width:100%;height:' + $el.height() + 'px;'
                    }));
                }
            },
            isDisabled: function () {
                return (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DOCUMENTS_TAB_ID)
                    && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_DOCUMENTS)) || PJQ.app.session.user == null || !PJQ.app.session.get('ownsPortal');
            }
        }),
        new PJQ.nav.NavItem({
            id: "bidfiler",
            title: "Bid Filer",
            sortOrder: 60,
            icon: "fa-file-import",
            feature: "bidFiler",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('bidFiler.isAdmin');
            },
            render: function ($el) {
                new PJQ.views.BidFiler({
                    el: $el
                });
            },
            isDisabled: function () {
                if (PJQ.app.session.isPanteraPortal()) {
                    return false;
                }

                return !PJQ.app.session.get('ownsPortal')
                    || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FILER);
            }
        }),
        new PJQ.nav.NavItem({
            id: "printondemand",
            title: "Order Prints",
            sortOrder: 70,
            icon: "fa-print",
            hasRoute: true,
            render: function ($el) {
                initPrintOnDemand($el);
            },
            isDisabled: function () {
                return !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PRINT_ON_DEMAND);
            }
        }),
        new PJQ.nav.NavItem({
            id: "profile",
            title: "Profile",
            sortOrder: 80,
            icon: "fa-user",
            hasRoute: true,
            requiresDirectory: true,
            render: function ($el, options) {
                new PJQ.views.profile.CompanyProfile({
                    el: $el,
                    key: options ? options.key : null,
                    activateTab: options ? options.tab : null
                });
            },
            isDisabled: function () {
                let companyType = null;
                if (PJQ.app.session.user != null) {
                    companyType = PJQ.app.session.user.get('companyType');
                }
                return !PJQ.app.session.isPanteraPortal() || companyType != 'SUB';
            }
        }),
        new PJQ.nav.NavItem({
            id: "prequal",
            title: "Prequalification",
            sortOrder: 80,
            icon: "fa-align-justify",
            hasRoute: true,
            hasPermission: function () {
            	return PJQ.app.session.isPanteraPortal() || PJQ.app.session.hasPermission('prequal.canView');
            },
            requiresDirectory: true,
            render: function ($el) {
                let terms = new PJQ.collections.screenings.ScreeningTerms(),
                    renderDashboard = function () {
                        let clients = new PJQ.collections.screenings.ScreeningClients(null, {
                            contact: PJQ.app.session.contact,
                            masterUserId: PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.constants.publicUserId
                        });
                        clients.fetch({
                            success: function () {
                                new PJQ.views.screenings.ScreeningDashboard({
                                    el: $el,
                                    collection: clients
                                });
                            },
                            error: function (model, result) {
                                new PJQ.logging.Debug(PJQ.logging.LoggingActions.PJQPROFILE_GET_SCREENINGS, {
                                    model: model,
                                    result: result
                                });
                            }
                        });
                    };
                terms.fetch({
                    success: function () {
                        if (_.find(terms.models, function (term) {
                            return term.get('isActive') && !term.get('isAccepted')
                        }) != null) {
                            new PJQ.views.screenings.ScreeningTermsModal({
                                collection: terms,
                                onComplete: function () {
                                    renderDashboard();
                                }
                            });
                        } else {
                            renderDashboard();
                        }
                    }
                });
            },
            isDisabled: function () {
                let companyType = null,
                    isPanteraPortal = PJQ.app.session.isPanteraPortal();
                if (PJQ.app.session.user != null) {
                    companyType = PJQ.app.session.user.get('companyType');
                }
                return ((PJQ.app.session.get('ownsPortal') && !isPanteraPortal) || (companyType !== "SUB" && isPanteraPortal)) || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PREQUAL);
            }
        }),
        new PJQ.nav.NavItem({
            id: "screenings",
            title: "Screenings",
            sortOrder: 90,
            icon: "fa-user",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.isPanteraPortal() || PJQ.app.session.hasPermission('prequal.canView');
            },
            render: function ($el, options) {
                let terms = new PJQ.collections.screenings.ScreeningTerms(),
                    renderDashboard = function () {
                        let clients = new PJQ.collections.screenings.ScreeningClients(null, {
                            contact: PJQ.app.session.contact,
                            masterUserId: PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.constants.publicUserId
                        });
                        clients.fetch({
                            success: function () {
                                new PJQ.views.screenings.ScreeningDashboard({
                                    el: $el,
                                    collection: clients
                                });
                            },
                            error: function (model, result) {
                                new PJQ.logging.Debug(PJQ.logging.LoggingActions.PJQPROFILE_GET_SCREENINGS, {
                                    model: model,
                                    result: result
                                });
                            }
                        });
                    };
                terms.fetch({
                    success: function () {
                        if (_.find(terms.models, function (term) {
                            return term.get('isActive') && !term.get('isAccepted')
                        }) != null) {
                            new PJQ.views.screenings.ScreeningTermsModal({
                                collection: terms,
                                onComplete: function () {
                                    renderDashboard();
                                }
                            });
                        } else {
                            renderDashboard();
                        }
                    }
                });
            },
            isDisabled: function () {
                return true;
            }
        }),
        new PJQ.nav.NavItem({
            id: "calendar",
            title: "Calendar",
            sortOrder: 100,
            icon: "fa-calendar-alt",
            feature: "calendar",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('calendar.canView');
            },
            render: function ($el) {
                if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_OLD_CALENDAR)) {
                    initScheduler($el);
                } else {
                    new PJQ.views.calendars.SystemCalendar({
                        el: $el
                    });
                }
            },
            isDisabled: function () {
                return PJQ.app.session.user == null;
            }
        }),
        new PJQ.nav.NavItem({
            id: "resources",
            title: "Resources",
            sortOrder: 105,
            icon: "fa-person-carry",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('resources.isAdmin');
            },
            render: function ($el) {
                new PJQ.views.resources.ResourceAllocation({
                    el: $el
                });
            },
            isDisabled: function () {
                return !PJQ.app.session.get('ownsPortal');
            }
        }),
        new PJQ.nav.NavItem({
            id: "timecards",
            title: "Time Cards",
            sortOrder: 106,
            icon: "fa-user-clock",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('timeCards.canView') || PJQ.app.session.hasPermission('timeCards.isAdmin');
            },
            render: function ($el) {
                new PJQ.views.timecards.TimeCardMain({
                    el: $el
                });
            },
            isDisabled: function () {
                return !PJQ.app.session.get('ownsPortal');
            }
        }),
        new PJQ.nav.NavItem({
            id: "invoices",
            title: "Invoices",
            sortOrder: 107,
            icon: "fa-file-invoice-dollar",
            hasRoute: true,
            hasPermission: function () {
                // either already on, or in demo mode
                return PJQ.app.session.hasPermission('invoices.canView') || PJQ.app.session.hasPermission('invoices.isAdmin') || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_INVOICES);
            },
            render: function ($el, options) {
                if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_INVOICES)) {
                    new PJQ.views.invoices.InvoicePreview({
                        el: $el
                    });
                } else {
                    new PJQ.views.invoices.Invoices(_.defaults({
                        el: $el
                    }, options));
                }
            },
            isDisabled: function () {
                return PJQ.app.session.get('onAccount') ||
                    (PJQ.app.session.subscription == null || (PJQ.app.session.subscription.id !== PJQ.constants.subscriptions.types.PRO && PJQ.app.session.subscription.id !== PJQ.constants.subscriptions.types.ENTERPRISE));
            }
        }),
        new PJQ.nav.NavItem({
            id: "erpadmin",
            sortOrder: 108,
            title: "ERP Admin",
            icon: "fa-check-to-slot",
            feature: "erpAdmin",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('settings.canManageERPAdmin');
            },
            path: function (options) {
                if (options) {
                    return 'erpadmin/' + options.feature;
                } else {
                    return 'erpadmin';
                }
            },
            render: function ($el, options) {
                new PJQ.views.erpAdmin.ERPAdminManagement({
                    el: $el,
                    feature: options.feature
                });
            },
            isDisabled: function () {
                return !PJQ.app.session.get('ownsPortal') || PJQ.app.session.erpIntegration == null || PJQ.app.session.erpIntegration.id == null;
            }
        }),
        new PJQ.nav.NavItem({
            id: "reports",
            sortOrder: 110,
            title: "Reports",
            icon: "fa-chart-line",
            feature: "reports",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('reports.canView');
            },
            render: function ($el) {
                initSystemReports($el);
            },
            isDisabled: function () {
                return !PJQ.app.session.get('ownsPortal');
            }
        }),
        new PJQ.nav.NavItem({
            id: "reportsadhoc",
            sortOrder: 110,
            title: "Ad Hoc Reports",
            icon: "fa-chart-line",
            feature: "reports",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.hasPermission('reports.canView');
            },
            render: function ($el) {
                PJQ.app.ReportView = new PJQ.views.reporting.NewReportView({
                    el: $el
                });
            },
            isDisabled: function () {
                return !PJQ.app.session.get('ownsPortal') || (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_REPORTS_NEW) && !(new RegExp("://sandbox.")).test(window.location.href)) ;
            }
        }),
        new PJQ.nav.NavItem({
            id: "settings",
            title: "Settings",
            sortOrder: 120,
            icon: "fa-cog",
            hasRoute: true,
            render: function ($el, options) {
                if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_SETTINGS)) {
                    initSystemSettings($el);
                } else {
                    PJQ.helpers.urlHelpers.cleanRouteParams();
                    new PJQ.views.settings.SettingsNav({
                        el: $el,
                        procoreCode: options.procoreCode,
                        subscriptionId: options.subscriptionId,
                        initView: options.initView
                    });
                }
            }
        }),
        new PJQ.nav.NavItem({
            id: "signout",
            title: "Sign Out",
            sortOrder: 130,
            icon: "fa-sign-out",
            hasPrecedingSeparator: true,
            route: function () {
                if (PJQ.app.options.isK8) {
                    window.location.href = "/signout";
                } else {
                    window.location.href = "/Signout.aspx";
                }
            }
        }),
        new PJQ.nav.NavItem({
            id: "resourcecenter",
            title: "Resource Center",
            sortOrder: 125,
            isAdmin: true,
            marginTop: '50px',
            iconImage: '/assets/modules2/global/images/wrench_icon.png',
            hasPermission: function () {
                return true
            },
            outsideRoute: 'https://www.panteratools.com/support/resource-center/',
            isDisabled: function () {
                return PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.HIDE_RESOURCE_CENTER);
            },
            includeMarkup: '<div class="d-flex justify-content-end"><div style="margin-top:-12px !important;font-weight: 400;font-size: 12px;" class="p-0 m-0 ht-20p lh-20 wd-85p">Click here for Tutorials ></div></div>'
        })
    ]),
    project: new PJQ.nav.NavItemGroup([
        new PJQ.nav.NavItem({
            id: "dashboard",
            title: "Dashboard",
            sortOrder: 10,
            icon: "fa-tachometer-alt-fast",
            hasRoute: true,
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/dashboard';
            },
            render: function ($el, options) {
                new PJQ.views.projects.ProjectDashboard(_.defaults({
                    el: $el,
                    model: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                if (PJQ.app.session.project) {
                    return PJQ.app.session.project.get('status') === 'ARCHIVE'
                        || PJQ.app.session.project.get('status') === 'NEW';
                }
            }
        }),
        new PJQ.nav.NavItem({
            id: "details",
            title: "Project Details",
            sortOrder: 20,
            icon: "fad fa-asterisk",
            hasRoute: true,
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/details';
            },
            render: function ($el, options) {
                this.projectDetails = new PJQ.views.projects.ProjectDetails(_.defaults({
                    el: $el,
                    model: PJQ.app.session.project
                }, options));
            },
            leaveView: function () {
                if (this.projectDetails != null) {
                    this.projectDetails.cancelEdit();
                }
            },
            hasPermission: function () {
                let proj = PJQ.app.session.project;
                return !proj.get('isDetailsAdminOnly') || (proj.get('masterUserId') === PJQ.app.session.get('masterUserId'));
            }
        }),
        new PJQ.nav.NavItem({
            id: "locations",
            title: "Locations",
            sortOrder: 25,
            icon: "fa-map-pin",
            hasRoute: true,
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/locations';
            },
            render: function ($el, options) {
                new PJQ.views.projects.LocationManagement(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('base.canEdit');
            },
            isDisabled: function () {
                return !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS);
            }
        }),
        new PJQ.nav.NavItem({
            id: "mall",
            title: "Mall",
            sortOrder: 20,
            isAdmin: true,
            icon: "fa-building",
            hasRoute: true,
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/mall';
            },
            render: function ($el, options) {
                let loader = new PJQ.Loader($el);
                PJQ.nav.getDataForOldProjectModules(function () {
                    window.pjqIsNewProjContainer = true;
                    if (loader != null) {
                        loader.remove();
                    }
                    $el.html('<div><button type="button" id="project-save" onclick="SaveProjContainer()" class="btn btn-primary mb-2">Save Changes</button><div id="project-container-home"></div></div>');
                    PanteraScript.PanteraScriptService.GetProjectContainerInfo(PJQ.app.session.id, ProjContainerInfoC, onScriptError);
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_CONTAINERS);
            }
        }),
        new PJQ.nav.NavItem({
            id: "messaging",
            title: function () {
                return PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_MESSAGING_TAB_NAME) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_MESSAGING_TAB_NAME) : "Messaging";
            },
            sortOrder: 30,
            icon: "fa-poll-people",
            isLegacy: function () {
                return !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROJECT_WALL_MESSAGING_NEW_PORTAL);
            },
            feature: "projectMessaging",
            isAdmin: true,
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('messaging.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/messaging';
            },
            render: function ($el, options) {
                if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROJECT_WALL_MESSAGING_NEW_PORTAL)) {
                    let muid = PJQ.app.session.get("masterUserId");
                    PJQ.app.session.fetchCompanyCustomFields(muid, _.bind(function () {
                        PJQ.app.session.fetchContactCustomFields(muid, _.bind(function () {
                            PJQ.app.session.fetchProjectMessageEmailTemplates(_.bind(function () {
                                new PJQ.views.projects.ProjectMessaging(_.defaults({
                                    el: $el,
                                    project: PJQ.app.session.project,
                                    copyProjectMessageId: options.copyProjectMessageId
                                }, options));
                            }, this));
                        }, this));
                    }, this));
                } else {
                    // cleanup for old itb module
                    if (window.dlgPM != null) {
                        window.dlgPM.dialog('destroy');
                        window.dlgPM = null;
                    }
                    window.msgEditor = null;
                    window.searchGroupList = '';
                    window.filterGroupTree = null;
                    window.filterUnsent = false;

                    window.validator = jQuery("Form[name='Form']").validate({
                        onsubmit: false,
                        onkeyup: false,
                        showErrors: function showErrors(errorMap, errorList) {
                            for (var i = 0; errorList[i]; i++) {
                                var element = this.errorList[i].element;
                                //solves the problem with brute force
                                //remove existing error label and thus force plugin to recreate it
                                //recreation == call to error placement function
                                this.errorsFor(element).remove();
                            }
                            this.defaultShowErrors();
                        },
                        errorPlacement: function errorPlacement(error, element) {
                            error.html('<br />' + error.text());
                            if (element.attr('tagName') == 'select' || element.hasClass('pjq-numeric-field-width'))
                                error.appendTo(element.parent().parent());
                            else
                                error.appendTo(element.parent());
                        },
                        errorClass: "pjq-errortext",
                        ignore: "pjq-validate-ignore"
                    });

                    //Render old itb modules
                    let loader = new PJQ.Loader($el),
                        render = function (options) {
                            $('.ui-dialog').remove();

                            let $itb = $('<div />', {
                                id: 'project-itb'
                            });
                            $el.html($itb);
                            PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, 'ITB', {isOldModule: true}), $itb, {}, function () {
                                // render project documents hidden because some of the dialogs are needed for messaging
                                let $docs = $('<div />', {
                                    id: 'project-documents',
                                    class: 'hidden'
                                });
                                $el.append($docs);
                                PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, 'ProjectDocuments', {isOldModule: true}), $docs, {}, function () {
                                    gridITB = null;
                                    PJQProjectWallAdminITBInitialize();
                                    InitializeGridITB(gridITBGroupBy, _.bind(function () {
                                        if (options.viewProjectMessageId)
                                            HandleViewProjectMessage(options.viewProjectMessageId);
                                        else if (options.copyProjectMessageId) {
                                            CopyProjectMsg(options.copyProjectMessageId);
                                        } else if (options.deleteProjectMessageId) {
                                            selectedCommentId = options.deleteProjectMessageId;
                                            showInfoDialog('Delete Message', 'Are you sure you want to delete this Project Message?', 'ui-icon-alert', 'delete-project-message');
                                        }
                                    }, this));
                                    $itb.find('.btn-new-message').attr('id', 'create-new-itb').removeClass('hidden');
                                });
                            });
                        };
                    //we have to check a certain value within window.settings to make sure its the project settings
                    //all old modules used a global settings variable
                    if (window.settings == null || window.settings.ProjectUser1Label == null || window.project == null || window.settings.projectId !== PJQ.app.session.project.id) {
                        PJQ.nav.getDataForOldProjectModules(function () {
                            render(options);
                            if (loader != null) {
                                loader.remove();
                            }
                        });
                    } else {
                        render(options);
                        if (loader != null) {
                            loader.remove();
                        }
                    }
                }
            },
            isDisabled: function () {
                if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROJECT_WALL_MESSAGING_NEW_PORTAL)) {
                    return false;
                }

                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_WALL_MESSAGING_OLD);
            }
        }),
        new PJQ.nav.NavItem({
            id: "messagingnew",
            title: function () {
                return PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_MESSAGING_TAB_NAME) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_MESSAGING_TAB_NAME) : "Messaging";
            },
            sortOrder: 30,
            icon: "fa-poll-people",
            feature: "projectMessaging",
            isAdmin: true,
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('messaging.canView');
            },
            path: function (options) {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/messagingnew' + ((options && options.viewProjectMessageId) ? '/' + options.viewProjectMessageId : '');
            },
            render: function ($el, options) {
                PJQ.app.session.fetchCompanyCustomFields(PJQ.app.session.get("masterUserId"), _.bind(function () {
                    PJQ.app.session.fetchContactCustomFields(PJQ.app.session.get("masterUserId"), _.bind(function () {
                        PJQ.app.session.fetchProjectMessageEmailTemplates(_.bind(function () {
                            new PJQ.views.projects.ProjectMessaging(_.defaults({
                                el: $el,
                                project: PJQ.app.session.project,
                                copyProjectMessageId: options.copyProjectMessageId
                            }, options));
                        }, this));
                    }, this));
                }, this));
            },
            isDisabled: function () {
                if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROJECT_WALL_MESSAGING_NEW_PORTAL)) {
                    return true;
                }
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROJECT_WALL_MESSAGING_NEW);
            }
        }),
        new PJQ.nav.NavItem({
            id: "privatemessaging",
            title: "Private Messages",
            sortOrder: 40,
            icon: "fa-comments-alt",
            feature: "privateMessaging",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('privateMessaging.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/privatemessaging';
            },
            render: function ($el, options) {
                new PJQ.views.projects.UserMessages({
                    el: $el,
                    project: PJQ.app.session.project,
                    userMessageId: options.viewUserMessageId,
                    view: options.view ? options.view : 'inbox'
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || (PJQ.app.session.user === null && PJQ.app.session.contact === null)
                    || PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_PRIVATE_MESSAGES);
            }
        }),
        new PJQ.nav.NavItem({
            id: "bidforms",
            title: "Bid Forms",
            sortOrder: 50,
            icon: "fa-file-invoice-dollar",
            feature: "bidForms",
            isAdmin: true,
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId') && PJQ.app.session.project.hasPermission('bidForms.canView');
            },
            path: function (options) {
                if (options && options.groupId > 0) {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/bidforms/' + options.groupId.toString();
                }
                return 'projects/' + PJQ.app.session.project.id.toString() + '/bidforms';
            },
            render: function ($el, options) {
                PJQ.app.BidFormEditor = new PJQ.views.bidForms.BidFormEditorSelector(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project,
                    collection: new PJQ.collections.bidForms.GroupBidForms([]),
                    initProposalId: options.proposalId,
                    initGroupId: options.groupId
                }, options));
            },
            isDisabled: function () {
                let hasPref = PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FORMS)
                    || PJQ.app.session.isPanteraPortal();
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW' || !hasPref || !PJQ.app.session.project.get('featureSettings').isBidFormsEnabled;
            }
        }),
        new PJQ.nav.NavItem({
            id: "proposals",
            title: "Proposals",
            sortOrder: 60,
            icon: "fa-file-invoice-dollar",
            isAdmin: false,
            hasRoute: true,
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/proposals';
            },
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('bidForms.canView');
            },
            render: function ($el, options) {
                new PJQ.views.bidForms.ProposalSelector({
                    el: $el,
                    model: new PJQ.models.bidForms.Bidder({
                        contactId: PJQ.app.session.contact.id
                    })
                });
            },
            isDisabled: function () {
                if (PJQ.app.session.contact == null)
                    return true;

                let itemPref = this.getNavPref();
                if (itemPref != null && itemPref.isDisabled != null) {
                    return itemPref.isDisabled;
                }

                let hasPref = PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FORMS)
                    || (PJQ.app.session.isPanteraPortal() && PJQ.app.session.project.get('portalId') === 4);
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || !hasPref
                    || !PJQ.app.session.project.get('featureSettings').isBidFormsEnabled
                    || PJQ.app.session.contact == null;
            }
        }),
        new PJQ.nav.NavItem({
            id: "projectcontacts",
            title: "Project Contacts",
            sortOrder: 70,
            icon: "fa-users-class",
            isAdmin: true,
            hasRoute: true,
            isPrimaryProjectManagerCheckExempt: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('projectContacts.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/contacts';
            },
            render: function ($el, options) {
                PJQ.app.projectContactsManagement = new PJQ.views.projectContacts.ProjectContactsManagement(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_CONTACTS);
            }
        }),
        new PJQ.nav.NavItem({
            id: "projectdocuments",
            title: "Documents",
            sortOrder: 80,
            icon: "fa-folder-tree",
            feature: "projectAttachments",
            isAdmin: true,
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('attachments.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/documents';
            },
            render: function ($el, options) {
                //Render old project documents module
                let loader = new PJQ.Loader($el),
                    render = function () {
                        let $docs = $('<div />', {
                            id: 'project-documents'
                        });
                        $el.append($docs);
                        PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, 'ProjectDocuments', {isOldModule: true}), $docs, {}, function () {
                            window.loPDocs = null;
                            PJQProjectWallAdminProjectDocumentsInitialize();
                        });
                    };
                if (window.settings == null) {
                    PJQ.nav.getDataForOldProjectModules(function () {
                        render();

                        if (loader != null) {
                            loader.remove();
                        }
                    });
                } else {
                    render();
                    if (loader != null) {
                        loader.remove();
                    }
                }
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_DOCUMENTS);
            }
        }),
        new PJQ.nav.NavItem({
            id: "drawings",
            title: "Drawings",
            sortOrder: 90,
            icon: "fa-ruler",
            feature: "drawings",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('drawings.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/drawings';
            },
            render: function ($el, options) {
                new PJQ.views.drawings.Dashboard({
                    el: $el,
                    project: PJQ.app.session.project,
                    isReadOnly: PJQ.app.session.project.get('status') === 'ARCHIVE',
                    initOptions: options
                });
            },
            isDisabled: function () {
                let proj = PJQ.app.session.project;
                return proj.get('status') === 'NEW'
                    || proj.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_DRAWINGS)
                    || (!proj.get('hasDrawings') && (PJQ.app.session.user == null || proj.get('masterUserId') !== PJQ.app.session.user.get('masterUserId')));
            }
        }),
        new PJQ.nav.NavItem({
            id: "attachments",
            title: "Attachments",
            sortOrder: 100,
            icon: "fa-paperclip",
            feature: "projectAttachments",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('attachments.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/attachments';
            },
            render: function ($el) {
                new PJQ.views.projects.Attachments({
                    el: $el,
                    expandSharedFolders: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.EXPAND_PROJECT_ROOT_SHARED_FOLDERS),
                    project: PJQ.app.session.project,
                    isReadOnly: PJQ.app.session.project.get('status') === 'ARCHIVE'
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'NEW' ||
                    PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_ATTACHMENTS);
            }
        }),
        new PJQ.nav.NavItem({
            id: "projectphotos",
            title: "Photo Gallery",
            sortOrder: 110,
            icon: "fa-images",
            feature: "projectPhotos",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('photoGallery.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/photos';
            },
            render: function ($el, options) {
                PJQ.app.ProjectPhotoGallery = new PJQ.views.photos.PhotoGallery(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_PHOTOS);
            }
        }),
        new PJQ.nav.NavItem({
            id: "meetings",
            title: "Meetings",
            sortOrder: 108,
            icon: "fa-people-group",
            feature: "meetings",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('meetings.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/meetings';
            },
            render: function ($el, options) {
                new PJQ.views.meetings.MeetingsList({
                    el: $el,
                    project: PJQ.app.session.project,
                    meetingId: options.meetingId
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        }),
        new PJQ.nav.NavItem({
            id: "projectschedule",
            title: "Schedule",
            category: PJQ.constants.navigation.categories.FIELD_TOOLS,
            sortOrder: 105,
            icon: "fad fa-tasks-alt",
            feature: "schedule",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('schedule.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/schedule';
            },
            render: function ($el, options) {
                new PJQ.views.schedule.ScheduleDashboard({
                    el: $el,
                    project: PJQ.app.session.project,
                    model: options.model,
                    initTaskId: options.taskId,
                    initLookAheadId: options.lookAheadId,
                    shareKey: options.shareKey
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW' ||
                    PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_SCHEDULING);
            }
        }),
        new PJQ.nav.NavItem({
            id: "rfi",
            title: "RFI",
            sortOrder: 120,
            icon: "fa-question",
            feature: "rfi",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('rfi.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/rfi';
            },
            render: function ($el, options) {
                PJQ.app.session.project.fetchRFISettings(_.bind(function (settings) {
                    PJQ.app.RFIManagement = new PJQ.views.rfi.RFIManagement(_.defaults({
                        el: $el,
                        settings: settings,
                        project: PJQ.app.session.project
                    }, options));
                }, this));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_RFI)
                    || (PJQ.app.session.user === null && PJQ.app.session.contact === null);
            }
        }),
        new PJQ.nav.NavItem({
            id: "submittals",
            title: "Submittals",
            sortOrder: 130,
            icon: "fa-conveyor-belt-alt",
            feature: "submittals",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('submittals.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/submittals';
            },
            render: function ($el, options) {
                new PJQ.views.submittals.SubmittalsView({
                    el: $el,
                    project: PJQ.app.session.project,
                    initSubmittalId: options.submittalId
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
            }
        }),
        new PJQ.nav.NavItem({
            id: "dailyreports",
            title: "Daily Reports",
            sortOrder: 140,
            icon: "fa-calendar-day",
            feature: "dailyReports",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('dailyReports.canView');
            },
            path: function (options) {
                let url = 'projects/' + PJQ.app.session.project.id + '/dailyreports';
                if (options != null && options.date != null) {
                    url += '/' + PJQ.helpers.dateHelpers.getDateString(options.date, PJQ.helpers.dateHelpers.dateFormats.URL_DATE);
                }
                return url;
            },
            render: function ($el, options) {
                PJQ.app.DailyReportsManagement = new PJQ.views.dailyReports.DailyReportsNavigator(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_DAILY_REPORTS);
            }
        }),
        new PJQ.nav.NavItem({
            id: "timecardsProject",
            title: "Time Cards",
            sortOrder: 144,
            icon: "fa-user-clock",
            hasRoute: true,
            hasPermission: function () {
                //TODO: This has to either be a user of the company that owns this project, or assigned as a ProjectManagementContact
                return (
                    (PJQ.app.session.contact == null && PJQ.app.session.hasPermission('timeCards.canView')) ||
                    ((PJQ.app.session.project.hasPermission('timeCards.canView') && PJQ.app.session.project.get('isProjectContact')) || PJQ.app.session.project.hasPermission('timeCards.canViewAll')));
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/timecards';
            },
            render: function ($el) {
                let contact = null;
                if ((PJQ.app.session.contact === null && PJQ.app.session.hasPermission('timeCards.canView')) || PJQ.app.session.project.hasPermission('timeCards.canViewAll'))
                    contact = null;
                else if (PJQ.app.session.project.hasPermission('timeCards.canView'))
                    contact = PJQ.app.session.user;
                else
                    contact = PJQ.app.session.contact;

                new PJQ.views.timecards.TimeCardMain({
                    el: $el,
                    project: PJQ.app.session.project,
                    contact: contact
                });
            }
        }),
        new PJQ.nav.NavItem({
            id: "punchlists",
            title: "Punch List",
            sortOrder: 150,
            icon: "fa-clipboard-check",
            feature: "punchList",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('punchList.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/punchlists';
            },
            render: function ($el, options) {
                PJQ.app.PunchlistView = new PJQ.views.punchlists.PunchlistView(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
            }
        }),
        new PJQ.nav.NavItem({
            id: "actionitems",
            title: "Action Items",
            sortOrder: 150,
            icon: "fa-clipboard-check",
            feature: "actionItems",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('actionItems.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/actionitems';
            },
            render: function ($el, options) {
                PJQ.app.ActionItemsView = new PJQ.views.actionItems.ActionItemView(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
            }
        }),
        new PJQ.nav.NavItem({
            id: "projectreports",
            title: "Reports",
            sortOrder: 160,
            icon: "fa-chart-pie",
            feature: "projectReports",
            isAdmin: true,
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('reports.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/reports';
            },
            render: function ($el, options) {
                //Render old Reports module
                let render = function () {
                    PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, 'ProjectReports', {isOldModule: true}), $el, {}, function () {
                        PJQProjectWallAdminProjectReportsInitialize();
                        BuildReportProject();
                    });
                };
                if (window.settings == null || window.settings.projectId !== PJQ.app.session.project.id) {
                    PJQ.nav.getDataForOldProjectModules(function () {
                        render();
                    });
                } else {
                    render();
                }
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        }),
        new PJQ.nav.NavItem({
            id: "projectreportsadhoc",
            title: "Ad Hoc Reports",
            sortOrder: 160,
            icon: "fa-chart-pie",
            feature: "projectReports",
            isAdmin: true,
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('reports.canView');
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/reportsadhoc';
            },
            render: function ($el, options) {
                PJQ.app.ReportView = new PJQ.views.reporting.NewReportView({
                    el: $el,
                    project: PJQ.app.session.project
                });
            },
            isDisabled: function () {
                return (PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW') || (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_REPORTS_NEW) && !(new RegExp("://sandbox.")).test(window.location.href));
            }
        }),
        new PJQ.nav.NavItem({
            id: "rsvpautoreport",
            title: function () {
                let result = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_RSVP_AUTO_REPORT);
                if (result.indexOf('|') !== -1)
                    result = result.substring(0, result.indexOf('|'));
                return result;
            },
            sortOrder: 165,
            icon: "fa-info",
            isAdmin: false,
            route: function () {
                let options = {};
                new PJQ.views.projects.AutoReport(_.defaults({
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_RSVP_AUTO_REPORT);
            }
        }),
        new PJQ.nav.NavItem({
            id: "costcodes",
            title: "Cost Codes",
            sortOrder: 169,
            icon: "fa-money-check-dollar",
            feature: "budget",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('budget.isAdmin') && PJQ.app.session.user != null;
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/costcodes';
            },
            render: function ($el, options) {
                this.costCodeSettings = new PJQ.views.budget.ProjectCostCodeSettings({
                    el: $el,
                    project: PJQ.app.session.project
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        }),
        new PJQ.nav.NavItem({
            id: "budget",
            title: "Budget",
            sortOrder: 170,
            icon: "fa-clipboard-check",
            feature: "budget",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('budget.canView') && PJQ.app.session.user != null;
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/budget';
            },
            render: function ($el, options) {
                PJQ.app.BudgetView = new PJQ.views.budget.ProjectBudget(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            }
        }),
        new PJQ.nav.NavItem({
            id: "primecontracts",
            title: "Contracts",
            sortOrder: 170,
            icon: "fa-signature",
            feature: "primecontracts",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('primeContracts.canView') && PJQ.app.session.user != null;
            },
            path: function (options) {
                if (options) {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/contracts/' + options.view;
                } else {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/contracts';
                }
            },
            render: function ($el, options) {
                new PJQ.views.primeContracts.PrimeContractManagement(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            }
        }),
        new PJQ.nav.NavItem({
            id: "commitments",
            title: "Commitments",
            sortOrder: 170,
            icon: "fa-money-bill",
            feature: "budget",
            hasRoute: true,
            requireSignUp: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('commitments.canView') && PJQ.app.session.user != null;
            },
            path: function (options) {
                if (options) {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/commitments/' + options.view;
                } else {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/commitments';
                }
            },
            render: function ($el, options) {
                new PJQ.views.commitments.CommitmentManagement(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            }
        }),
        new PJQ.nav.NavItem({
            id: "changerequests",
            title: "Change Requests",
            sortOrder: 172,
            icon: "fa-money-bill-transfer",
            feature: "changerequests",
            hasRoute: true,
            requireSignUp: true,
            hasPermission: function () {
                return PJQ.app.session.user != null
                    && (PJQ.app.session.project.hasPermission('changeRequests.canView') || PJQ.app.session.project.hasPermission('changeRequests.canViewRFQs'));
            },
            path: function (options) {
                if (options) {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/changerequests/' + options.view;
                } else {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/changerequests';
                }
            },
            render: function ($el, options) {
                new PJQ.views.changeRequests.ChangeRequestsList(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW';
            }
        }),
        new PJQ.nav.NavItem({
            id: "directcosts",
            title: "Direct Costs",
            sortOrder: 175,
            icon: "fa-envelope-open-dollar",
            feature: "budget",
            hasRoute: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('directCosts.canView') && PJQ.app.session.user != null;
            },
            path: function () {
                return 'projects/' + PJQ.app.session.project.id.toString() + '/directcosts';
            },
            render: function ($el, options) {
                new PJQ.views.directcosts.ProjectDirectCosts(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            }
        }),
        new PJQ.nav.NavItem({
            id: "invoicing",
            title: "Invoicing",
            sortOrder: 180,
            icon: "fa-file-invoice-dollar",
            feature: "invoicing",
            hasRoute: true,
            hasPermission: function () {
                return (PJQ.app.session.project.hasPermission('payableInvoices.isAdmin') || PJQ.app.session.project.hasPermission('receivableInvoices.isAdmin')) && PJQ.app.session.user != null;
            },
            path: function (options) {
                if (options) {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/invoicing/' + options.view;
                } else {
                    return 'projects/' + PJQ.app.session.project.id.toString() + '/invoicing';
                }
            },
            render: function ($el, options) {
                new PJQ.views.invoicing.InvoicingManagement(_.defaults({
                    el: $el,
                    project: PJQ.app.session.project
                }, options));
            }
        })
    ], {
        hasHeader: true
    }),
    nonAdminExtras: new PJQ.nav.NavItemGroup([
        new PJQ.nav.NavItem({
            id: "cloneproject",
            title: "Clone Project",
            sortOrder: 300,
            icon: "fa-clone",
            isAdmin: false,
            hasPrecedingSeparator: true,
            route: function () {
                let cloneModal = new PJQ.views.modals.YesNo({
                    header: "Clone Project",
                    body: "Are you sure you want to clone this into your projects?",
                    onYes: function () {
                        new PJQ.Loader(cloneModal.$('.modal-content'));
                        PJQ.app.session.project.clone(function (newProject) {
                            cloneModal.remove();
                            PJQ.modules.projectWall.initProjectNavigator(newProject.id, "dashboard");
                            PJQ.notifications.notify.successNotify({
                                message: 'Project cloned successfully'
                            });
                        });
                    }
                });
            },
            isDisabled: function () {
                return !PJQ.app.session.isLoggedIn() || !PJQ.app.session.get('ownsPortal');
            }
        }),
        new PJQ.nav.NavItem({
            id: "followproject",
            title: "Follow Project",
            sortOrder: 310,
            icon: "fa-bell",
            isAdmin: false,
            hasPrecedingSeparator: true,
            route: function () {
                new PJQ.views.contacts.BaseEditContactModal({
                    model: new PJQ.models.projectContacts.ProjectContact({
                        id: PJQ.app.session.contact.id,
                        projectId: PJQ.app.session.project.id
                    }),
                    alert: "Please review and update your contact details before registering your account",
                    onSave: function () {
                        new PJQ.views.auth.AuthModal({
                            contactId: PJQ.app.session.contact.id,
                            mode: PJQ.app.session.contact.get('userId') > 0 ? 'SIGN_IN' : 'SIGN_UP',
                            isShowCloseButton: true
                        });
                    }
                });
            },
            isDisabled: function () {
                return PJQ.app.session.isLoggedIn() || PJQ.app.session.contact == null;
            }
        })
    ]),
    adminExtras: new PJQ.nav.NavItemGroup([
        new PJQ.nav.NavItem({
            id: "copyproject",
            title: "Copy Project",
            sortOrder: 320,
            icon: "fa-clone",
            isAdmin: true,
            hasPrecedingSeparator: true,
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('base.canCopy');
            },
            route: function () {
                let copyModal = new PJQ.views.modals.YesNo({
                    header: "Copy Project",
                    body: "Are you sure you want to copy this project?",
                    onYes: function () {
                        new PJQ.Loader(copyModal.$('.modal-content'));
                        PJQ.app.session.project.copy(function (newProject) {
                            copyModal.remove();
                            PJQ.modules.projectWall.initProjectNavigator(newProject.id, "dashboard");
                            PJQ.notifications.notify.successNotify({
                                message: 'Project copied successfully'
                            });
                        });
                    }
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_COPY_PROJECT);
            }
        }),
        new PJQ.nav.NavItem({
            id: "orderprints",
            title: "Order Prints",
            sortOrder: 325,
            icon: 'fa-shopping-cart',
            isAdmin: true,
            hasPermission: function () {
                return true;
            },
            route: function () {
                new PJQ.views.files.OrderPrintsModal({
                    mode: PJQ.constants.files.modes.ALT_PRINT,
                    project: PJQ.app.session.project
                })
            },
            isDisabled: function () {
                return !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PLAN_EXPRESS_PORTAL);
            }
        }),
        new PJQ.nav.NavItem({
            id: "bluebookpublish",
            title: "Message The Blue Book",
            sortOrder: 325,
            isAdmin: true,
            iconImage: '/assets/modules2/global/images/thebluebook.png',
            hasPermission: function () {
                return PJQ.app.session.project.hasPermission('messaging.canManage');
            },
            route: function () {
                new PJQ.views.projects.BlueBookPublishModal({
                    project: PJQ.app.session.project
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_BLUE_BOOK_PUBLISH);
            },
            extraMarkup: '<li class="nav-item"><div class="d-flex justify-content-end"><a style="margin-top:-8px !important;font-weight: 400;font-size: 14px;" class="nav-button-label nav-link p-0 m-0 mr-4 ht-20p lh-20 wd-85p" target="_blank" href="https://www.panteratools.com/the-blue-book-network/">See Details ></a></div></li>'
        }),
        new PJQ.nav.NavItem({
            id: "procorepublish",
            title: "Publish to Procore",
            sortOrder: 330,
            isAdmin: true,
            iconImage: '/assets/modules2/global/images/procore.png',
            route: function () {
                let loader = new PJQ.Loader($('div.nav-body'));
                new PJQ.ajax.Request({
                    endpoint: '/procore/settings/-1'
                }).get().done(_.bind(function (response) {
                    if (loader != null) {
                        loader.remove();
                    }

                    let fnContinue = function(response, procoreProjectNumber) {
                        new PJQ.views.projects.ProcorePublishModal({
                            settings: response,
                            procoreProjectNumber: procoreProjectNumber
                        });
                    };

                    if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROCORE_PROJECT_NUMBER_CUSTOM_FIELD)) {
                        let customFieldLabel = '', customFieldValue = '', customFieldId = parseInt(PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROCORE_PROJECT_NUMBER_CUSTOM_FIELD));

                        _.each(PJQ.app.session.project.customFields.models, function(customField) {
                            if (customField.get('id') == customFieldId)
                                customFieldLabel = customField.get('fieldName');
                        });

                        _.each(PJQ.app.session.project.attributes.customFields, function(customFieldValueTemp) {
                            if (customFieldValueTemp.id == customFieldId)
                                customFieldValue = customFieldValueTemp.value;
                        });

                        if (_.size(customFieldValue) == 0)
                        {
                            PJQ.notifications.notify.errorNotify({
                                message: customFieldLabel + ' must be entered in order to Publish to Procore'
                            });
                        }
                        else {
                            fnContinue(response, customFieldValue);
                        }
                    }
                    else {
                        fnContinue(response);
                    }
                }, this)).fail(_.bind(function (xhr, err, result) {
                    PJQ.notifications.notify.errorNotify({
                        message: 'Unable to retrieve Procore settings!'
                    });
                }, this));
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROCORE_CLIENT_ID)
                    || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROCORE_ACCESS_REFRESH_TOKEN)
                    || _.size(PJQ.app.session.project.get('externalProjectId')) > 0;
            }
        }),
        new PJQ.nav.NavItem({
            id: "procoreview",
            title: "View in Procore",
            sortOrder: 340,
            isAdmin: true,
            iconImage: '/assets/modules2/global/images/procore.png',
            route: function () {
                let data = PJQ.app.session.project.get('externalProjectId').substring(8);
                new PJQ.views.BaseModal({
                    header: "Procore Project",
                    body: '<a href="https://api.procore.com/' + data + '/project/home" target="_blank">Click here</a> to open your Procore project in a new window.'
                });
            },
            isDisabled: function () {
                return PJQ.app.session.project.get('status') === 'ARCHIVE'
                    || PJQ.app.session.project.get('status') === 'NEW'
                    || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROCORE_CLIENT_ID)
                    || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROCORE_ACCESS_REFRESH_TOKEN)
                    || (_.size(PJQ.app.session.project.get('externalProjectId')) === 0 || !PJQ.app.session.project.get('externalProjectId').startsWith('PROCORE:'));
            }
        })
    ])
};

PJQ.views.nav = {};
PJQ.views.nav.AppNavigator = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Navigator'),
        subTemplates: {
            commands: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Navigator-Commands'),
            signUpMessage: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'app-navigator-sign-up-message')
        },
        itemGroups: [],
        isAdmin: true
    },
    events: {
        'click .nav-link': 'navigate',
        'click .btn-to-top': 'backToTop',
        'click .btn-start-tour': 'startTour'
    },
    beforeInit: function () {
        if (PJQ.app.options.isNavExpanded == null) {
            PJQ.app.options.isNavExpanded = window.innerWidth > 768;
        }
        this.$el.off();
    },
    expandNav: function (e) {
        let $nav = this.$('.app-navigator');
        $nav.toggleClass('expanded');
        PJQ.app.options.isNavExpanded = $nav.hasClass('expanded');
    },
    beforeFirstRender: function () {
        this.renderHeaderNavExpandButton();
        this.renderHeaderSubscription();
    },
    renderHeaderNavExpandButton: function () {
        let $header = $('.skin-header');
        if (_.size($header) > 0 && _.size($('.btn-expand-nav')) === 0) {
            let bgColor = $header.css('background-color'),
                btnColor = _.size(bgColor) > 0 ? PJQ.helpers.colorHelpers.idealLinkColorForBackground(PJQ.helpers.colorHelpers.getHexFromRGB(bgColor)) : '#fff',
                $expand = $('<i style="color:' + btnColor + ';" class="fad fa-bars btn-expand-nav fa-2x ml-3"></i>');
            $header.prepend($expand);
            $expand.on('click', _.bind(this.expandNav, this));
        }
    },
    renderHeaderSubscription: function () {
        if (PJQ.app.session.user != null && !PJQ.app.session.get('onAccount') && PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId) {
            $('.subscription-name').remove();
            $('.start-tour').remove();

            let $header = $('.skin-header'),
                showTrial = PJQ.app.session.subscription.get('isFreeTrial') && (PJQ.app.session.subscription.newSubscription != null && PJQ.app.session.subscription.newSubscription.id === PJQ.constants.subscriptions.types.FREE),
                $subscription = $('<span class="fs-14 subscription-name"> ' + PJQ.helpers.formatHelpers.upperCaseFirstLetterEachWord(PJQ.app.session.subscription.get('name').toLowerCase()) + (showTrial ? ' Trial' : '') + '</span>');
            $header.append($subscription);
            if (showTrial) {
                let days = PJQ.helpers.dateHelpers.getDateDiff(new Date(PJQ.app.session.subscription.get('trialExpiresOn')), new Date(), 'days') + 1;
                let $daysRemaining = $('<span class="fs-12"> (' + days.toString() + 'd remaining)</span>')
                $subscription.append($daysRemaining)
            }
            if (PJQ.app.session.user.get('tourDone') && !PJQ.app.session.get('onAccount') && PJQ.app.session.subscription.get('subscriptionId') > 1) {
                let $startTourButton = $('<div class="start-tour" style="position: absolute; right: 0; margin-right: 20px;"><button type="button" class="btn btn-link text-light btn-start-tour">Start Tour</button></div>');
                $header.append($startTourButton);
                $('.btn-start-tour').on('click', _.bind(function () {
                    this.startTour();
                }, this))
            }
        }
    },
    beforeRender: function () {
        if (this.options.activeItem != null) {
            let mainItem = PJQ.nav.itemGroups.main == null ? null : _.findWhere(PJQ.nav.itemGroups.main.items, {id: this.options.activeItem});
            if (mainItem != null) {
                // if they are navigating to a main nav item, they will never have a project
                // so we make sure its null
                PJQ.app.session.project = null;
            }
        } else {
            // there isn't an active item provided, default to the first enabled main item
            let defActiveItem = _.find(PJQ.nav.itemGroups.main.items, function (item) {
                return !item.getIsDisabled() && item.hasPermission() && item.hasFeature();
            });
            if (defActiveItem != null) {
                this.options.activeItem = defActiveItem.id;
            }
        }

        this.user = PJQ.app.session.user;
        this.project = PJQ.app.session.project;
    },
    renderData: function () {
        return {
            project: this.project,
            context: this.options.context,
            isExpanded: PJQ.app.options.isNavExpanded
        };
    },
    afterRender: function () {
        //remove dhtml tooltips for calendar (temporary until old calendar is phased out)
        $('.dhtmlXTooltip').remove();

        this.determineCommands();
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_TOP_OF_PAGE_BUTTON)) {
            $('.scroll-to-top').append('<a id="btntotop" class="btn-to-top" style="display: none;">\n' +
                '<span class="fas fa-chevron-up"></span>\n' +
                '</a>');
            this.$('div.nav-content').on('scroll', _.bind(function () {
                if (this.$('div.nav-content')[0].scrollTop > 100) {
                    $('.btn-to-top').fadeIn(300);

                } else {
                    $('.btn-to-top').fadeOut(300);
                }
            }, this));
        }

        this.setActiveItem(this.options.activeItem);
        this.options.activeItem = null;

        this.renderCommands();
        this.renderHeader();
        this.renderActiveItem(false);

        if (PJQ.app.session.user != null && !PJQ.app.session.get('onAccount') && PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId) {
            let trialCookie = PJQ.constants.cookies.SUBSCRIPTION_FREE_TRIAL + "-" + PJQ.app.session.user.id.toString();
            if (PJQ.app.session.subscription.get('trialExpiresOn') == null && !PJQ.helpers.cookieHelpers.getCookie(trialCookie) && false) {
                new PJQ.views.subscriptions.EditSubscriptionModal({
                    onSave: _.bind(function (type) {
                        PJQ.helpers.tours.initTour();
                    }, this)
                });
                PJQ.helpers.cookieHelpers.setCookie(trialCookie, true, 14);
            } else if (!this.options.preventTour && !PJQ.app.navInit && !PJQ.app.session.user.get('tourDone') && PJQ.app.session.subscription.get('subscriptionId') > 1) {
                PJQ.app.navInit = true;
                PJQ.helpers.tours.initTour();
            }

            let expireCookie = PJQ.constants.cookies.SUBSCRIPTION_EXPIRES_ALERT + "-" + PJQ.app.session.user.id.toString();
            if (PJQ.app.session.subscription.newSubscription != null && !PJQ.helpers.cookieHelpers.getCookie(expireCookie)) {
                let expiresOnDays = PJQ.helpers.dateHelpers.getDateDiff(new Date(PJQ.app.session.subscription.get('expiresOn')), new Date(), 'days') + 1;
                if (expiresOnDays <= 14 && expiresOnDays > 0) {
                    let expirationText,
                        isDowngrade = PJQ.app.session.subscription.newSubscription.id !== PJQ.constants.subscriptions.types.FREE;
                    if (isDowngrade) {
                        // its a paid downgrade
                        expirationText = "Your current plan will be downgraded in " + expiresOnDays.toString() + (expiresOnDays === 1 ? " day" : " days") + ".  Upgrade your account to keep your current features!  <a class='btn-change-sub no-trial' href='#settings'>Upgrade Now</a>";
                    } else {
                        // its a downgrade to a free account
                        let isFreeTrial = PJQ.app.session.subscription.get('isFreeTrial');
                        expirationText = "Your " + (isFreeTrial ? "free trial" : "current plan") + " will expire in " + expiresOnDays.toString() + (expiresOnDays === 1 ? " day" : " days") + ".  Upgrade your account to keep your project progress!  <a class='btn-change-sub no-trial' href='#settings'>Upgrade Now</a>";
                    }
                    new PJQ.Alert(this.$('.nav-content'), {
                        type: "sub-expiration",
                        text: expirationText,
                        isPrepend: true,
                        cookie: expireCookie,
                        cookieExpirationDays: expiresOnDays === 1 ? 1 : expiresOnDays / (isDowngrade ? 1.5 : 2) //show this alert every half time (shows more as it gets closer to expiration)
                    });
                }
            }

            if (PJQ.app.session.contact && PJQ.app.session.contact.get('isBlacklisted') && !PJQ.app.session.contact.get('isApprovalRequired')) {
                new PJQ.views.BaseModal({
                    header: "Directory Information Required",
                    body: "Additional information is required in order to be included in the Pantera Directory and begin receiving Project Invites.  Please ensure all information is accurate and complete.",
                    isShowSecondaryButton: true,
                    okButtonText: 'Update Information',
                    secondaryButtonText: 'Cancel',
                    onOk: _.bind(function () {
                        window.location.href = 'https://app.panteratools.com/?cg='+PJQ.app.session.contact.get('updateGuid')+'/#register';
                    }, this)
                });
            }
        }
    },
    startTour: function () {
        new PJQ.views.tours.SubscriptionTourIntro();
    },
    determineCommands: function () {
        if (this.project != null) {
            this.projectMenuItems = [];
            this.projectMenuItems.push(...PJQ.nav.itemGroups.project.items);

            if (this.project.get('masterUserId') === PJQ.app.session.get('masterUserId')) {
                this.projectMenuItems.push(...PJQ.nav.itemGroups.adminExtras.items);
            } else {
                if (this.project.userMessageTypes != null) {
                    let userTypeId = PJQ.app.session.contact ? PJQ.app.session.contact.get('userTypeId') : (PJQ.app.session.user ? PJQ.app.session.user.get('userTypeId') : null),
                        actionItems = _.filter(this.project.userMessageTypes.models, function (item) {
                            return _.size(item.get('actionButtonText')) > 0 && item.get('userMessageType').toLowerCase() !== 'bid submittal' && (!item.get('userTypeId') || item.get('userTypeId') === userTypeId);
                        });

                    let sortOrder = 300;
                    _.each(actionItems, function (item, index) {
                        let menuItem = new PJQ.nav.NavItem({
                            id: 'msg_' + item.id.toString(),
                            title: item.get('actionButtonText'),
                            sortOrder: sortOrder,
                            icon: "fa-clone",
                            isAdmin: false,
                            hasPrecedingSeparator: index === 0,
                            route: _.bind(function () {
                                new PJQ.views.projects.UserMessageModal({
                                    project: this.project,
                                    userMessageTypeId: item.id
                                });
                            }, this)
                        });
                        this.projectMenuItems.push(menuItem);

                        sortOrder = sortOrder + 10;
                    }, this);
                }
                this.projectMenuItems.push(...PJQ.nav.itemGroups.nonAdminExtras.items);
            }
        }
    },
    refreshCommands: function () {
        this.determineCommands();
        this.renderCommands();
    },
    renderCommands: function () {
        this.renderSubTemplate(false, this.options.subTemplates.commands, this.$('.nav-commands-container'), {
            project: this.project,
            projectMenuItems: this.projectMenuItems,
            activeItem: this.activeItem,
            context: this.options.context ? this.options.context : ""
        });
    },
    setActiveItem: function (id) {
        let result = PJQ.nav.itemGroups.main == null ? null : _.findWhere(PJQ.nav.itemGroups.main.items, {id: id});
        if (result != null) {
            PJQ.app.session.project = null;
            this.project = null;
            if (result.hasRoute) {
                this.activeItem = result;
            }
        } else if (this.project != null) {
            result = _.findWhere(this.projectMenuItems, {id: id});
            if (result != null) {
                if (result.hasRoute) {
                    this.activeItem = result;
                }
            }
        } else {
            this.activeItem = null;
        }

        // they tried to navigate to a disabled active item
        if (PJQ.app.session.project) {
            if (this.activeItem == null || this.activeItem.getIsDisabled()) {
                if (this.project != null) {
                    let isProjectAdmin = PJQ.app.session.get('masterUserId') === this.project.get('masterUserId');
                    this.activeItem = _.find(PJQ.nav.itemGroups.project.items, function (item) {
                        return item.hasFeature() && item.hasPermission() && !item.getIsDisabled() && (item.getIsAdmin() == null || isProjectAdmin === item.getIsAdmin());
                    });
                } else {
                    this.activeItem = _.find(PJQ.nav.itemGroups.main.items, function (item) {
                        return item.hasFeature() && item.hasPermission() && !item.getIsDisabled();
                    });
                }
            }
        }

        return result;
    },
    renderHeader: function () {
        if (this.user != null) {
            this.userHeader = new PJQ.views.nav.UserHeader({
                el: this.$('.app-nav-user-header'),
                model: this.user
            });
        } else if (this.userHeader != null) {
            this.userHeader.remove();
        }

        if (this.project != null) {
            this.projectHeader = new PJQ.views.nav.ProjectHeader({
                el: this.$('.app-nav-project-header'),
                model: this.project
            });
        } else if (this.projectHeader != null) {
            this.projectHeader.remove();
        }
    },
    renderActiveItem: function (triggerRoute) {
        let $navBody = this.$('.nav-body');
        if (this.activeItem != null) {
            if (this.activeItem.route(this.options.viewOptions, triggerRoute, $navBody) === false) {
                return;
            }

            if (this.activeItem.id === 'dashboard') {
                $navBody.addClass('module-content-gray');
            } else {
                $navBody.removeClass('module-content-gray');
            }

            // if (this.activeItem.requireSignUp) {
            //     this.renderSignUpMessage($navBody);
            // } else {
            //     this.activeItem.render($navBody, this.options.viewOptions != null ? this.options.viewOptions : {});
            // }

            this.activeItem.render($navBody, this.options.viewOptions != null ? this.options.viewOptions : {});

            if (this.project != null && PJQ.app.session.get('masterUserId') === this.project.get('masterUserId') && this.activeItem.isPrimaryProjectManagerCheckExempt !== true && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_PRIMARY_PROJECT_MANAGER_REQUIRED) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK)) {
                let fnPMR = _.bind(function () {
                    // fetch project contacts
                    PJQ.app.session.project.fetchProjectContacts(_.bind(function () {
                        let primaryPM = null;
                        _.each(PJQ.app.session.project.projectContacts.models, _.bind(function (projectContact) {
                            if (projectContact.get('isPrimary')) {
                                _.each(PJQ.app.session.userTypes.models, _.bind(function (userType) {
                                    // see if userType is a PM
                                    if (userType.get('userTypeId') === projectContact.get('userTypeId') && userType.get('isProjectManager'))
                                        primaryPM = projectContact;
                                }, this));
                            }
                        }, this));

                        if (!primaryPM) {
                            new PJQ.views.BaseModal({
                                header: "Primary Project Manager Required",
                                body: 'Please add or select a Primary Project Manager in the Project Contacts list.',
                                isShowCancelButton: false,
                                onOk: _.bind(function () {
                                    PJQ.app.router.navigate('projects/' + PJQ.app.session.project.get('projectId') + '/contacts', {
                                        trigger: true
                                    });
                                }, this)
                            });
                        }
                    }, this));
                }, this);

                let value = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_PRIMARY_PROJECT_MANAGER_REQUIRED);
                if (value == 'true') {
                    fnPMR();
                } else {
                    let cfid = value.split('|')[0], targetValues = value.split('|')[1].split(',');
                    _.each(PJQ.app.session.project.get('customFields'), _.bind(function (fieldValue) {
                        if (parseInt(cfid) === fieldValue.id) {
                            if (targetValues.indexOf(fieldValue.value.toString()) !== -1)
                                fnPMR();
                        }
                    }, this));
                }
            }

            document.title = this.activeItem.getDocumentTitle();

            // this is here to allow for initial nav routing within it's content
            // for example, on RFI if we want to allow for /rfis/{rfiId}
            //  we don't want the initial load of the tab to route the to /rfis
            if (this.options.viewOptions != null && this.options.viewOptions.shouldDoFirstRoute === false) {
                this.options.viewOptions.shouldDoFirstRoute = null;
                return;
            }

            this.options.viewOptions = null;
        }
    },
    renderSignUpMessage: function ($el) {
        this.renderSubTemplate(false, this.options.subTemplates.signUpMessage, $el);
    },
    backToTop: function () {
        this.$('div.nav-content').animate({
            scrollTop: 0
        }, 500);
    },
    navigate: function (e) {
        if (this.activeItem.leaveView != null && typeof this.activeItem.leaveView === "function") {
            this.activeItem.leaveView();
        }
        if (this.$(e.currentTarget).hasClass('disabled'))
            return;
        let selectedItemId = this.$(e.currentTarget).data('action');
        if (_.size(selectedItemId) > 0 && (this.activeItem == null || selectedItemId !== this.activeItem.id)) {
            let activeItem = this.setActiveItem(selectedItemId);
            if (activeItem != null) {
                // only re-render the nav if this menu item actually has a render function
                // it could be an item that does some logic on route()
                if (!activeItem.hasRoute) {
                    if (typeof activeItem.route === 'function') {
                        activeItem.route();
                    } else if (typeof activeItem.render === 'function') {
                        this.render();
                    }
                }
            }
        }
    }
});

PJQ.views.nav.UserHeader = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Nav-User-Header')
    },
    beforeFirstRender: function () {
        //this.listenTo(this.model, 'sync change:projectName change:address1 change:address2 change:city change:state change:zip change:isFavorite change:bidsDue', this.render);
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model
        }
    }
});

PJQ.views.nav.ProjectHeader = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Nav-Project-Header')
    },
    events: {
        'click .btn-favorite-project': 'favoriteProject',
        'change .input-project-online': 'projectOnlineChanged',
        'click .btn-project-map': 'projectMap'
    },
    beforeFirstRender: function () {
        this.listenTo(this.model, 'sync change:projectName change:address1 change:address2 change:city change:state change:zip change:isFavorite change:bidsDue change:isOnline', this.render);
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model
        }
    },
    projectMap: function () {
        new PJQ.views.projects.ProjectMapModal();
    },
    favoriteProject: function () {
        this.model.set('isFavorite', this.model.get('isFavorite') === false, {
            silent: true
        });
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.model.id
                },
                {
                    endpoint: 'favorite'
                }
            ], [
                {
                    parameter: 'isFavorite',
                    value: this.model.get('isFavorite')
                }
            ]),
            data: { cloudFlareFix: true }
        }).put().done(_.bind(function () {
            this.render();
        }, this));
    },
    projectOnlineChanged: function () {
        let isOnline = this.$('.input-project-online').prop('checked');
        this.model.set('isOnline', isOnline);
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.model.id
                }
            ], [
                {
                    parameter: 'isOnline',
                    value: isOnline
                }
            ])
        }).patch().done(_.bind(function () {
            let alertMessage;
            if (isOnline) {
                alertMessage = "Project set to online";
            } else {
                alertMessage = "Project set to offline";
            }
            PJQ.notifications.notify.successNotify({
                message: alertMessage
            });
        }, this));
    }
});

PJQ.views.nav.RegisterDirectory = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'register-directory'),
    },
    events: {
        'click .btn-join-directory': 'joinDirectory'
    },
    joinDirectory: function () {
        PJQ.app.session.joinDirectory(_.bind(function () {
            if (typeof this.options.onRegister === 'function') {
                this.options.onRegister();
            }
        }, this));
    }
});

PJQ.views.modals.RegisterDirectoryModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-register-directory'),
    },
    beforeModalCreated: function () {
        this.options = _.defaults({
            onOk: _.bind(function () {
                PJQ.app.session.joinDirectory(_.bind(function () {
                    if (typeof this.options.onRegister === 'function') {
                        this.options.onRegister();
                    }
                    this.removeModal();
                }, this));
            }, this)
        }, this.options);
    }
});

/* Test commit */